<form (submit)="submitResetRequest()" [formGroup]="resetFormGroup" class="home-container">
  <div class="header-section">
    <div class="title">{{ 'app.user-form.reset' | translate }}</div>
    <i (click)="closeDialog()" class="pi pi-times icon-buttons"></i>
  </div>
  <div class="content-section">
    <div *ngIf="errorMessage" class="error-message">{{ errorMessage | translate }}</div>
    <div *ngIf="successMessage" class="success-message">{{ successMessage | translate }}</div>

    <div class="field-rows">
      <input
        class="ui-input pInputText input-field"
        formControlName="email"
        id="reset-input-email"
        pInputText
        placeholder="{{ 'app.user-form.email' | translate }}"
        size="30"
        type="text" />
    </div>

    <div class="reset-submit-button-section">
      <p-button
        class="full-width-button"
        id="reset-btn-submit"
        icon="{{ isLoading ? 'pi pi-spin pi-spinner' : 'null' }}"
        iconPos="right"
        type="submit"
        [disabled]="resetFormGroup.invalid"
        [label]="'app.user-form.reset-button' | translate"></p-button>
    </div>

    <div class="footer">
      <span class="back-login-section">
        <!-- <div>{{'app.user-form.goto-login' | translate}}</div> -->
        <p-button
          (click)="showLoginForm()"
          id="goto-login"
          class="login-button full-width-button"
          [label]="'app.user-form.login-button' | translate"></p-button>
      </span>
    </div>
  </div>
</form>
